export const experienceData = [
  {
    id: 1,
    company: "Amazon",
    jobtitle: "L5 Software Development Engineer",
    startYear: "2024 Jun",
    endYear: "Current",
  },
  {
    id: 2,
    company: "Amazon",
    jobtitle: "L4 Software Development Engineer",
    startYear: "2022 Sep",
    endYear: "2024 May",
  },
  {
    id: 3,
    company: "IX Online",
    jobtitle: "Junior Full Stack Developer",
    startYear: "2021 Dec",
    endYear: "2022 Aug",
  },
  {
    id: 4,
    company: "University of Kwa-Zulu Natal",
    jobtitle: "Post Graduate Assistant",
    startYear: "2021 Mar",
    endYear: "2021 Nov",
  },
  {
    id: 5,
    company: "Amazon",
    jobtitle: "Intern Software Development Engineer",
    startYear: "2021 Jan",
    endYear: "2021 Mar",
  },
  {
    id: 6,
    company: "University of Kwa-Zulu Natal",
    jobtitle: "Post Graduate Assistant",
    startYear: "2020 Jan",
    endYear: "2020 Dec",
  },
];
